'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._api_reception_executeUsingPost = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _api_reception_executeUsingPost = exports._api_reception_executeUsingPost = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', (0, _requestOlympics2.default)({
              url: (0, _request.urlPrefix)() + '/api/reception/execute',
              method: 'POST',
              data: _extends({
                actionCode: 'BatchMaterialList',
                viewId: 'BatchForm'
              }, params)
            }).then(resErrorJudge));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function _api_reception_executeUsingPost(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

var _request = require('../../adapter/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 *判断返回值
 * @param {Object} res 返回值
 * @returns Promise.reject or Promise.resolve
 */
function resErrorJudge(res) {
  if (!res || !res.success) {
    return Promise.reject(res);
  }
  return Promise.resolve(res.data);
}